import { reactive } from "vue";

export const contactsState = reactive({
  currentTab: "people",
  selectedPeopleId: null,
  selectedEntityId: null,
});
